//#region src/utils/calcMemo.ts
function calcMemoWidth(memo) {
	return 9 + memo.ui.width + 8 + 1;
}
function calcMemoHeight(memo) {
	return 25 + memo.ui.height + 8 + 1;
}
//#endregion
export { calcMemoHeight, calcMemoWidth };
